module.exports = __webpack_public_path__ + "static/media/live02_04_2018.45e56330.jpg";